import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Provider } from 'react-redux';
import { IntlProvider } from 'react-intl';

import MessageNotifier from '../../components/message-notifier/MessageNotifier';

class RootView extends Component {
    render() {
        const {
            store,
            component: Component,
            childProps
        } = this.props;

        return (
            <Provider store={store}>
                <IntlProvider locale="en">
                    <div>
                        <Component {...childProps} />
                        <MessageNotifier/>
                    </div>
                </IntlProvider>
            </Provider>
        );
    }

}

RootView.propTypes = {
    store: PropTypes.object.isRequired,
    component: PropTypes.func.isRequired
};

class SimpleRootView extends Component {
    render() {
        const {
            store,
            component: Component,
            childProps
        } = this.props;

        return (
            <Provider store={store}>
                <Component {...childProps} />
            </Provider>
        );
    }

}

SimpleRootView.propTypes = {
    store: PropTypes.object.isRequired,
    component: PropTypes.func.isRequired
};

export const wrapComponentWithRootView = (component, store) => {
    return (props) => (createElement(RootView, component, store, props));
};

export const wrapComponentWithProvider = (component, store) => {
    return (props) => (createElement(SimpleRootView, component, store, props));
};

export const createElement = (rootComponent, ...other) => (React.createElement(rootComponent, extendProps(...other)));

export const extendProps = (component, store, props) => (Object.assign({}, { component, store }, { childProps: props }));

export default RootView;
